import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";

const LAST_UPDATED = "10 July 2026";

const CookiePolicyPage = () => (
  <LegalDocumentPage
    eyebrow="Legal"
    title="Cookie Policy"
    summary="InfoBoxx uses cookies and similar technologies so the platform can remember your session, keep you signed in, and understand how people move through category journeys. This page explains what we use and how you can control it."
    lastUpdated={LAST_UPDATED}
    relatedLinks={[
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms & Conditions" },
    ]}
    sections={[
      {
        heading: "1. What are cookies?",
        paragraphs: [
          "Cookies are small text files stored on your device when you visit a website. Similar tools include local storage and session storage, which InfoBoxx may use for the same practical purposes — for example keeping you logged in after OTP verification or remembering UI state.",
        ],
      },
      {
        heading: "2. Why InfoBoxx uses them",
        paragraphs: [
          "We use cookies and similar storage to make a consumer decision platform work smoothly across phones and desktops.",
        ],
        bullets: [
          "Essential: keep your session secure, remember that you are signed in, and protect forms against abuse.",
          "Preferences: remember choices that improve your visit, such as recently viewed categories or dismissed prompts where we store that preference.",
          "Performance: understand which category hubs, topic pages, and CTAs people use so we can improve content and navigation.",
          "Partner journey support: help us measure whether users who request expert help successfully complete Ask · Learn · Talk · Book steps (without selling cookie data for unrelated ads).",
        ],
      },
      {
        heading: "3. Types of cookies we may use",
        paragraphs: [
          "Exact cookie names can change as we ship product updates. In practice they fall into these groups:",
        ],
        bullets: [
          "Strictly necessary — required for login, security, and core page functions. The site may not work correctly without these.",
          "Functional — remember settings that make InfoBoxx easier to use on return visits.",
          "Analytics — help us see aggregate traffic patterns (for example popular Legal or Real Estate topics) so we can improve the experience.",
        ],
      },
      {
        heading: "4. Third-party tools",
        paragraphs: [
          "Some pages may load third-party services — for example appointment booking widgets or embedded media. Those providers may set their own cookies under their policies. We choose tools that support the InfoBoxx experience and expect them to process data only as needed for that feature.",
        ],
      },
      {
        heading: "5. How long cookies last",
        paragraphs: [
          "Session cookies expire when you close your browser. Persistent cookies remain for a set period or until you delete them. Authentication and preference storage may last longer so you do not have to re-verify every visit, subject to security timeouts.",
        ],
      },
      {
        heading: "6. Your controls",
        paragraphs: [
          "You can block or delete cookies through your browser settings. If you disable essential cookies, features such as sign-in, interest-gated articles, or saved profile state may stop working.",
          "Where we introduce a cookie preference banner or similar control, your choices there will apply in addition to browser settings.",
        ],
      },
      {
        heading: "7. Updates and contact",
        paragraphs: [
          "We may update this Cookie Policy when our technology or legal requirements change. The “Last updated” date at the top of this page will change when we do.",
          "For privacy questions beyond cookies, read our Privacy Policy or email info@infoboxx.com.",
        ],
      },
    ]}
  />
);

export default CookiePolicyPage;
